import {DomainObject} from 'shared/store';
import { action, computed, observable, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import SurveyAnswer from './SurveyAnswer';
import _ from 'lodash';
import {generateAnonymousEmployee} from 'shared/tools';
import Survey from './Survey';

class SurveyResponse extends DomainObject {
  survey;
  employee = new Employee(generateAnonymousEmployee());
  answers;

  _relations = {
    survey: Survey,
    employee: Employee,
    answers: [SurveyAnswer]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      survey: observable,
      employee: observable,
      answers: observable,
      readOnly: computed,
      sortedAnswers: computed,
      regenerateAnswersForQuestions: action
    });

    this.merge(other);
  }

  get readOnly() {
    return !this.hasLink('submit');
  }

  get sortedAnswers() {
    return _.sortBy(this.answers, 'question.order');
  }

  regenerateAnswersForQuestions(questions) {
    let newAnswers = [];
    let currentAnswers = _.keyBy(this.answers, 'question.id');

    _.forEach(questions, q => {
      let answer = new SurveyAnswer({question: q});
      if (currentAnswers[q.id] !== undefined) {
        answer.content = currentAnswers[q.id].content;
      }
      newAnswers.push(answer);
    });

    this.answers = newAnswers;
  }
}

export default SurveyResponse;
